import { useEffect } from 'react';

// Injects a page-specific manifest and home-screen name while the page is open,
// so iPhone Add to Home Screen saves each list as its own standalone app.
// The manifest link is created dynamically (not in index.html) so Safari reads
// the correct one at "Add to Home Screen" time rather than a cached site default.
const useHomeScreenApp = (manifestHref: string, title: string, touchIconHref?: string) => {
  useEffect(() => {
    // Create the manifest link — it doesn't exist in index.html on purpose.
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.setAttribute('href', manifestHref);
    document.head.appendChild(link);

    // Inject a page-specific apple-touch-icon so iOS uses it instead of favicon.
    let touchIcon: HTMLLinkElement | null = null;
    if (touchIconHref) {
      touchIcon = document.createElement('link');
      touchIcon.rel = 'apple-touch-icon';
      touchIcon.setAttribute('href', touchIconHref);
      document.head.appendChild(touchIcon);
    }

    let appTitle = document.querySelector<HTMLMetaElement>(
      'meta[name="apple-mobile-web-app-title"]'
    );
    const addedAppTitle = !appTitle;
    const previousAppTitle = appTitle?.content;
    if (!appTitle) {
      appTitle = document.createElement('meta');
      appTitle.name = 'apple-mobile-web-app-title';
      document.head.appendChild(appTitle);
    }
    appTitle.content = title;

    const previousTitle = document.title;
    document.title = title;

    return () => {
      link.remove();
      touchIcon?.remove();
      if (addedAppTitle) appTitle?.remove();
      else if (appTitle && previousAppTitle !== undefined) appTitle.content = previousAppTitle;
      document.title = previousTitle;
    };
  }, [manifestHref, title]);
};

export default useHomeScreenApp;
